import { BaseService } from "@/script/core/service/BaseService";
import { CallBack, Failure, Success } from "@/script/core/service/DataService";
import { OrderCountReport, OrderStatesReport, TotalCountReport } from "../entity/ReportEntity";


class ReportService extends BaseService {
  public loadOrderStates(callBack: CallBack<OrderStatesReport>) {
    const api = "/api/report/admin/order/states";
    super.get(api, {}).then(
      function (result) {
        callBack(result.data);
      },
      function (error: Error) {
        console.error(error);
      }
    );
  }

  public loadOrderDayCount(callBack: CallBack<OrderCountReport>) {
    const api = "/api/report/admin/order/day/counts";
    super.get(api, {}).then(
      function (result) {
        callBack(result.data);
      },
      function (error: Error) {
        console.error(error);
      }
    );
  }

  public loadTotalCount(callBack: CallBack<TotalCountReport>) {
    const api = "/api/report/admin/total/counts";
    super.get(api, {}).then(
      function (result) {
        callBack(result.data);
      },
      function (error: Error) {
        console.error(error);
      }
    );
  }
}

export { ReportService };
